/**
 * Function that fills a number up with zeros
 * @param num: Number that should be filled
 * @param places: to how many letters
 * @returns Url friendly string
 */
const zeroPad = (num, places) => String(num).padStart(places, '0');

export default zeroPad;
